import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse,HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

import {SharedService} from './shared.service'

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

  @BlockUI() blockUI: NgBlockUI;

  constructor(private sharedService: SharedService, private http: HttpClient) {
  }

  private totalRequests = 0;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //intercept(req: HttpRequest<any>, next: HttpHandler) {
    this.totalRequests++;
    const started = Date.now();

    //if (req.url.indexOf("bam.nr-data.net") === -1) {
    if (req.url.indexOf("awqrfile") === -1) {
      this.blockUI.start('Loading..');
    }
    else {
      this.blockUI.start('Processing..'); //for downloading Annual Report PDF
    }

    return next.handle(req)
      .pipe(
        tap(
          resp => {
            if (resp instanceof HttpResponse) {
              this.decreaseRequests();
            }
          },
          error => {
            this.decreaseRequests();
            this.logError(error);
          }
        ),
        // Log when response observable either completes or errors
        finalize(() => {
          const elapsed = Date.now() - started;
          if (elapsed > 60000) {
            const msg = `${req.method} "${req.urlWithParams}" in ${elapsed} ms.`;
            console.log("Call exceeds 1 Minute. Message at finalize in Http interceptor ", msg);
          }
        })
      );
  }

  private decreaseRequests() {
    this.totalRequests--;
    if (this.totalRequests === 0) {
      this.blockUI.stop();
    }
  }

  private logError(error:any) {
    const hostName = window.location.hostname;
    let serviceUrl = '';
    if (hostName.indexOf("uatwater.ny.gov") != -1) {
      serviceUrl = "https://uatwater.ny.gov/doh7/waterqual/services/emailFrontEndErrors";
    }
    else if (hostName.indexOf("evalwater.ny.gov") != -1) {
      serviceUrl = "https://evalwater.ny.gov/doh7/waterqual/services/emailFrontEndErrors";
    }
    else if (hostName.indexOf("devwater.ny.gov") != -1) {
      serviceUrl = "https://devwater.ny.gov/doh7/waterqual/services/emailFrontEndErrors";
    }
    else if (hostName.indexOf("water.ny.gov") != -1) {
      serviceUrl = "https://water.ny.gov/doh7waterqual/services/emailFrontEndErrors";
    }
    else {
      //serviceUrl = "https://devwater.ny.gov/doh7/waterqual/services/emailFrontEndErrors";
      serviceUrl = "http://localhost:8081/doh7/waterqual/services/emailFrontEndErrors";  // testing
    }
    if (error) {
      let errMsg = error.message ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      console.log("Error Message " + errMsg, error, JSON.stringify(error));
    }

    this.http.post(serviceUrl, JSON.stringify(error)).subscribe(
      success => { },
      err => console.error("Error in Email Error() call::", err),
      () => { }
    );
  }
}
